import React, { Component } from 'react'

class MessageGroupCustom extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { group, groupCustomId } = this.props

        return (
            <div style={{ cursor: 'pointer' }}>
                <span className="qListItem" style={{ fontSize: 14 }} onClick={() => this.props.editGroup(group)}>({group.users.length} medlemmar) {group.groupName}</span> &nbsp;&nbsp;&nbsp;
                <span onClick={() => this.props.removeCustomGroups([groupCustomId])} style={{ color: '#bb1010', cursor: 'pointer' }}>Ta bort</span>
            </div>
        )
    }
}

export default MessageGroupCustom